export default __webpack_public_path__ + "assets/change-over-time.mp4";